import { Icon } from "@iconify/react/dist/iconify.js";
import { ButtonBase, Checkbox, Grid, Popover } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import SearchBar from "./Searchbar";
import Helpers from "../../helpers/helpers";
import CustomButton from "../Form/CustomButton";
import CustomTextField from "../Form/CustomTextField";

export default function PopoverFilter2({ module, title, value, marginLeft, marginRight, filterData, setValue, placeholder, paddingInline, notShowingModuleTitle, onChangeMoculeCatgory }) {
    const [menu, setMenu] = useState(null);
    const [keyword, setKeyword] = useState(null);
    const [checkedAll, setCheckedAll] = useState(value === 'all' ? true : false);
    const [moduleChecked, setModuleChecked] = useState([]);
    const [valueChecked, setValueChecked] = useState([]);
    const [currentExpand, setCurrentExpand] = useState();

    const openPopoverHandle = useCallback((event) => {
        setMenu(event.currentTarget);
    }, []);

    const closePopover = useCallback(() => {
        setMenu(null);
    }, []);

    useEffect(() => {
        if (value === 'all') {
            setCheckedAll(true);
        } else if (Array.isArray(value)) {
            setValueChecked(value || []);
        }
    }, [value])

    useEffect(() => {
        if (filterData) {
            let allValues = [];
            let allModules = [];
            filterData?.length && filterData.forEach(data => {
                allModules.push(data.module);
                const moduleValues = data.list.map(item => item.id || item[data.valueName]);
                allValues = [...allValues, ...moduleValues];
            })
        }
    }, [filterData])

    useEffect(() => {
        if (checkedAll) {
            const allModules = filterData?.length ? filterData?.map(data => data.module) : [];
            const allValues = filterData?.length ? filterData.flatMap(data => data.list.map(item => item.id || item[data.valueName])) : [];
            setModuleChecked(allModules);
            onChangeMoculeCatgory && onChangeMoculeCatgory(allModules);
            setValueChecked(allValues);
        } else {
            setModuleChecked([]);
            setValueChecked([]);
            onChangeMoculeCatgory && onChangeMoculeCatgory([]);
        }
    }, [checkedAll]);

    useEffect(() => {
        if ((moduleChecked.length !== filterData.length) && checkedAll) {
            setCheckedAll(false);
        }
    }, [moduleChecked]);

    const handleValueChecked = (val) => {
        const isValNumber = !isNaN(val);
        if (isValNumber) {
            val = Number(val);
        }
        let updatedList = [...valueChecked];
        if (updatedList.includes(val)) {
            updatedList = updatedList.filter((item) => item !== val);
        } else {
            updatedList.push(val);
        }
        setValueChecked(updatedList);

        if (notShowingModuleTitle) return;

        // Check if the value's module should be checked or unchecked
        const moduleData = filterData?.find(d => d.list.some(item => (item.id || item[d.valueName]) === val));
        if (moduleData) {
            const moduleValues = moduleData.list.map(item => item.id || item[moduleData.valueName]);
            const allValuesChecked = moduleValues.every(v => updatedList.includes(v));
            if (allValuesChecked) {
                setModuleChecked(prev => [...prev, moduleData.module]);
                onChangeMoculeCatgory && onChangeMoculeCatgory(moduleData.module);
            } else {
                setModuleChecked(prev => prev.filter(m => m !== moduleData.module));
                onChangeMoculeCatgory && onChangeMoculeCatgory(moduleData.module);
            }
        }
    }

    const handleModuleChecked = (val) => {
        let updatedModuleList = [...moduleChecked];
        let updatedValueList = [...valueChecked];
        const moduleData = filterData?.find(d => d.module == val);
        const moduleValues = moduleData ? moduleData.list.map(item => item.id || item[moduleData.valueName]) : [];
        if (updatedModuleList.includes(val)) {
            // Uncheck module: remove its values from valueChecked
            updatedModuleList = updatedModuleList.filter((item) => item != val);
            updatedValueList = updatedValueList.filter((item) => !moduleValues.includes(item));
        } else {
            // Check module: add its values to valueChecked (if not already present)
            updatedModuleList.push(val);
            moduleValues.forEach(v => {
                if (!updatedValueList.includes(v)) {
                    updatedValueList.push(v);
                }
            });
        }
        setModuleChecked(updatedModuleList);
        setValueChecked(updatedValueList);
        onChangeMoculeCatgory && onChangeMoculeCatgory(updatedModuleList)
    }

    const handleApply = () => {
        setValue(valueChecked);
        closePopover();
    }

    const handleClearAll = () => {
        setCheckedAll(false);
        setModuleChecked([]);
        setValueChecked([]);
    }

    return (
        <React.Fragment>
            <ButtonBase
                style={{
                    height: 36,
                    borderRadius: 20,
                    backgroundColor: 'white',
                    color: '#101010',
                    padding: 7,
                    paddingInline: paddingInline || 10,
                    width: "100%",
                    display: 'flex',
                    justifyContent: 'flex-start',
                    border: "1px solid #c4c4c4",
                    marginRight: marginRight || 0,
                    marginLeft: marginLeft || 0,
                }}
                onClick={openPopoverHandle}
            >
                {
                    placeholder ?
                        <div className="d-flex justify-content-between w-100 px-2">
                            {
                                !value || (Array.isArray(value) && value.length === 0) ?
                                    <>
                                        <div className="subheader-2 d-flex" style={{ color: '#999999' }}>{module}</div>
                                    </>
                                    : <>
                                        <div>{module} ({value?.length || 0})</div>
                                    </>
                            }
                            <Icon icon={'ri-arrow-down-s-line'} style={{ color: !value || (Array.isArray(value) && value.length === 0) ? '#999999' : '#434343', fontSize: "20px", paddingLeft: "0px" }} />
                        </div>
                        :
                        <div className="d-flex justify-content-between align-items-center w-100 px-2">
                            <span className="subheader-2 d-flex">{module}: <span style={{ color: '#101010', marginLeft: 5 }}>{value === 'all' ? 'All' : value?.length > 0 ? `${value.length} selected` : 'all'}</span></span>
                            <Icon icon={'mdi:chevron-up-down'} style={{ marginLeft: 15, color: '#434343', fontSize: "15px", paddingLeft: "0px" }} />
                        </div>
                }
            </ButtonBase>
            <Popover
                sx={{
                    "& .MuiPaper-root": {
                        boxShadow: "0 2px 4px rgba(16, 16, 16, 0.08)",
                        borderRadius: "8px",
                        overflowX: 'auto'
                    },
                }}
                open={!!menu}
                anchorEl={menu}
                onClose={closePopover}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <div className="p-4" style={{ width: 360, position: 'relative' }}>
                    {/* <div className="d-flex justify-content-between mb-4">
                        <div className="text-bold font-size-16">{title}</div>
                        <div className="clickable" style={{ textDecoration: 'underline' }} onClick={() => { handleClearAll() }}>Clear all</div>
                    </div> */}
                    {/* <SearchBar value={keyword} setValue={setKeyword} /> */}
                    <CustomTextField
                        values={keyword}
                        onChange={(e) => setKeyword(e)}
                        placeholder={'Search by'}
                        height={50}
                        paddingBlock={1}
                        InputProps={{ startAdornment: <Icon icon={'fluent:search-16-regular'} style={{ marginRight: 8, height: 20, width: 20 }} /> }}
                    />
                    <div className="mt-4" style={{ maxHeight: 300, overflow: 'auto' }}>
                        <Grid container spacing={2}>
                            <Grid item sm={1.5} xs={1.5} className="d-flex align-items-center">
                                <Checkbox checked={checkedAll || filterData?.length === moduleChecked.length}
                                    checkedIcon={Helpers.checkIcon()}
                                    icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '2px solid #1D1B1B' }}></div>}
                                    sx={{
                                        '&.Mui-checked': {
                                            color: "#a0a0a0",
                                        },
                                        '& .MuiSvgIcon-root': {
                                            fontSize: 18,
                                        },
                                    }}
                                    value={checkedAll || filterData?.length === moduleChecked.length}
                                    onChange={(event) => setCheckedAll(!checkedAll)} />
                            </Grid>
                            <Grid item sm={10.5} xs={10.5} className="d-flex align-items-center text-bold">
                                Select all
                            </Grid>
                            {
                                filterData?.length > 0 && filterData?.map((x, idx) => {
                                    const filteredList = keyword ? x.list.filter(item => (item?.label || item?.[x.labelName] || '').toString().toLowerCase().includes(keyword.toLowerCase())) : x.list;
                                    return (
                                        <>
                                            {
                                                notShowingModuleTitle ? null :
                                                    <>
                                                        <Grid item sm={1.5} xs={1.5} className="d-flex align-items-center">
                                                            <Checkbox checked={moduleChecked?.includes(x?.module)}
                                                                checkedIcon={Helpers.checkIcon()}
                                                                icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '2px solid #1D1B1B' }}></div>}
                                                                sx={{
                                                                    '&.Mui-checked': {
                                                                        color: "#a0a0a0",
                                                                    },
                                                                    '& .MuiSvgIcon-root': {
                                                                        fontSize: 18,
                                                                    },
                                                                }}
                                                                value={x?.module}
                                                                onChange={(event) => handleModuleChecked(x?.module)} />
                                                        </Grid>
                                                        <Grid item sm={9} xs={9} className="d-flex align-items-center">
                                                            {x.name}
                                                        </Grid>
                                                        <Grid item sm={1.5} xs={1.5} className="d-flex align-items-center">
                                                            <ButtonBase className="p-1" style={{ borderRadius: '100%' }} onClick={() => setCurrentExpand(currentExpand === x.module ? "" : x.module)}>
                                                                <Icon icon={currentExpand == x.module ? 'solar:alt-arrow-up-linear' : 'solar:alt-arrow-down-linear'} />
                                                            </ButtonBase>
                                                        </Grid>
                                                    </>
                                            }

                                            {
                                                ((currentExpand == x.module && x?.list) || notShowingModuleTitle) && filteredList.map((item, index) => (
                                                    <>
                                                        <Grid item sm={3} xs={3} className="d-flex align-items-center justify-content-end">
                                                            <Checkbox checked={valueChecked?.includes(item?.id || item?.[x.valueName]) || moduleChecked?.includes(x?.module)}
                                                                checkedIcon={Helpers.checkIcon()}
                                                                icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '2px solid #1D1B1B' }}></div>}
                                                                sx={{
                                                                    '&.Mui-checked': {
                                                                        color: "#a0a0a0",
                                                                    },
                                                                    '& .MuiSvgIcon-root': {
                                                                        fontSize: 18,
                                                                    },
                                                                }}
                                                                value={item?.id || item?.[x.valueName]}
                                                                onChange={(event) => handleValueChecked(event.target.value)} />
                                                        </Grid>
                                                        <Grid item sm={9} xs={9} className="d-flex align-items-center">
                                                            {item?.label || item?.[x.labelName]}
                                                        </Grid>
                                                    </>
                                                ))
                                            }
                                        </>
                                    )
                                })
                            }
                        </Grid>
                    </div>
                    <div className="p-2 d-flex justify-content-center pt-3" style={{ backgroundColor: 'white' }}>
                        <CustomButton
                            title={'Apply'}
                            press={() => { handleApply() }}
                            padding={20}
                            width={'100%'}
                        />
                    </div>
                </div>
            </Popover>
        </React.Fragment>
    )
}